import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'

import Index from './components/Index';
import Navbar from './components/Navbar';
import TestView from './components/TestView';
import TestAddView from './components/TestAddView';
import About from './components/About';

import { PROFESSORS_URL, TESTS_URL } from './apiInfo';

class App extends Component {
	/*allTests = [
		{
			id: 1,
			year: 2016,
			month: 10,
			day: 5,
			class: '4.a',
			subject: 'INF',
			professor: 'Kušar Vincenc',
			image: ['/b_img/1.jpg'],
			description: 'Algoritmi...'
		}, ...]*/

	state = {
		classYear: 0,
		school: '',
		heading: '',
		selectedProfessor: '',
		selectedSubject: '',
		professors: [],
		tests: [],
		loadingState: ''
	};

	handleSearch = ({ professor, subject, school, classYear, fromAdd }) => {
		classYear = Number(classYear);

		//loads the list of professors for the school if school was changed and at the beginning
		if (!professor) {
			if (school !== this.state.school) {
				this.setState({ school, classYear });
				fetch(PROFESSORS_URL + school)
					.then(response => response.json())
					.then(response => this.setState({ professors: response }));
			}

			if (!fromAdd && (school !== this.state.school || classYear !== this.state.classYear)) {
				this.setState({ tests: [], heading: '' });
			}
		} else {
			console.log(professor);

			this.setState({
				classYear,
				school,
				selectedProfessor: professor,
				selectedSubject: subject,
			})

			this.setState({ tests: [], loadingState: 'Loading' });

			fetch(TESTS_URL + `?classYear=${classYear}&school=${school}&professor=${professor}&subject=${subject}`)
				.then(response => response.json())
				.then(response => {
					this.setState({
						heading: `Najdeni testi`,
						tests: response,
						loadingState: ''
					})
				});
		}
	}



	render() {
		return (
			<Router>
				<Navbar />
				<Switch>

					<Route path="/test/:id"
						render={(props) => <TestView {...props}
							tests={this.state.tests}
						/>}
					/>

					<Route path="/dodaj"
						render={(props) => <TestAddView {...props}
							school={this.state.school}
							classYear={this.state.classYear}
							professors={this.state.professors}
							onSearch={this.handleSearch}
							selected={{ professor: this.state.selectedProfessor, subject: this.state.selectedSubject }}
						/>}
					/>

					<Route path="/o"
						component={About}
					/>

					<Route path="/"
						render={(props) => <Index {...props}
							onSearch={this.handleSearch}
							{...this.state}
						/>}
					/>

				</Switch>
			</Router>
		);
	}
}

export default App;
